import React from 'react';
import { login } from 'account-portal-library/lib/googleSignIn';
import GoogleLogo from '../../../../static/images/TO/google-icon.svg'
import AppVars from '../../../../AppVars.js';
import Loader from '../../../Loader';
import pushAnalytics from '../../../../analytics/pushAnalytics.js';

const appVars = AppVars.getInstance();

class GoogleButton extends React.Component {
    constructor(props) {
        super(props);
        this.handleGoogleLogin = this.handleGoogleLogin.bind(this);
        this.state = { ...props }
    }

    async handleGoogleLogin() {
        window._dL = { ...(window._dL || {}), user_login_source: "Google" };

        pushAnalytics('aa-link', {
            ctaText: 'Continue with Google',
            link_text: 'Continue With Google',
            link_type: 'button',
            link_trigger: 'aa-link',
            content_section: 'Sign in Landing Page',
            metrics: 'km-sign-in-start',
            user_login_source: 'Google',
            user_entry_source: "Toyota"
        }, { component_name: "GoogleButton", component_version: "1.0.0" });

        await login(
            sessionStorage.AP_STYLE,
            appVars.getBaseUrl(),
            appVars.getRealm(),
            appVars.getGoogleSignInTree(),
            appVars.getDomain(),
            appVars.getName()
        )
    }

    render() {
        if (this.props.implicitRegister) {
            pushAnalytics("aa-component-view", { component_name: "GoogleButton", component_version: "1.0.0" });
            this.handleGoogleLogin();
            return (
                <Loader />
            )
        } else {
            return (
                <button alt="Continue With Google" onClick={this.handleGoogleLogin} className="button-box-google">
                    <span className="button-text button-text-google">Continue with Google</span>
                </button>
                // <img alt="Sign In with Google" onClick={this.handleGoogleLogin} src={GoogleButtonImg} className="button-social button-google"/>
            )
        }
    }
}

export default GoogleButton;